import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../../store';
import { ITempMessage } from '../../../models/temp-message';
import { loadTempMessages } from '../../../store/e-store/temp-message-actions';

import './temp-message.css';

import TempMessage from './temp-message';

interface ITempMessageProps {
    tempMessages: ITempMessage[];
    loadTempMessages: () => Promise<void>;
}

export const TempMessageContainer: React.FC<ITempMessageProps> = ({
    tempMessages,
    loadTempMessages,
}) => {
    useEffect(() => {
        if (tempMessages.length === 0) {
            loadTempMessages();
        }
    }, [tempMessages.length]);

    return (
        <div>
            <div className="temp-message-container">
                {tempMessages.length > 0 &&
                    tempMessages.map((msg: ITempMessage, index) => {
                        return (
                            <React.Fragment key={index}>
                                <TempMessage text={msg.text} />
                            </React.Fragment>
                        );
                    })}
            </div>
        </div>
    );
};

const mapStateToProps = (state: RootState) => ({
    tempMessages: state.tempMessages ? state.tempMessages.data! : [],
});

const mapDispatchToProps = {
    loadTempMessages,
};

const tempMessageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(TempMessageContainer);

export default tempMessageContainer;
